<div id="react-native-root">
  <ng-container *ngIf="isDesktop">
    <!-- <app-sidebar docked="true"></app-sidebar> -->
  </ng-container>
  <app-header id="react-native-header" [title]="homeName" *ngIf="!isDesktop">
  </app-header>
  <!-- <div id="offline-watermark" *ngIf="!online">
    <mat-icon>signal_cellular_connected_no_internet_4_bar</mat-icon>
    <span>Offline Or Slow Internet Speeds.</span>
    <span>This feature is not available.</span>
  </div> -->
  <!-- <div id="react-native-body-filler" *ngIf="!online"></div> -->
  <div id="react-native-body">
    <app-skeleton-loader
      id="skeleton-loader"
      *ngIf="online && !bundleLoaded"
    ></app-skeleton-loader>
  </div>
  <app-footer [featureBaseUrl]="baseUrl" *ngIf="!isDesktop"></app-footer>
</div>
